export default "__VITE_ASSET__CHCTqKLI__"